export default __webpack_public_path__ + "static/KV18-01-2f83f944d97b05a3a4dde7b0bcfa13c7.webp";